




















import Vue from 'vue';
import Navigation from '@/components/Navigation.vue';
import Header from '@/components/Header.vue';
import { setCssVariable } from '@/utils/styles';
// eslint-disable-next-line no-unused-vars
import { ICSSVariableConfig } from '@/utils/styles/setCssVariable';
import Y3DV2Logo from '@/components/Y3DV2Logo.vue';

export interface ILayoutY3DV2Data {
  rootVariables: ICSSVariableConfig;
}

export default Vue.extend({
  name: 'LayoutY3DV2',
  components: {
    Header,
    Navigation,
    Y3DV2Logo,
  },
  data: (): ILayoutY3DV2Data => ({
    rootVariables: [
      ['--cwb-container-background-color', 'rgb(33, 36, 41)'],
      ['--cwb-container-border-radius', '12px'],
      ['--cwb-connect-button-color', 'rgb(109, 168, 255)'],
      ['--cwb-connect-button-background-color', 'rgba(21, 61, 111, 0.44)'],
      ['--cwb-connect-button-border', 'solid 1px rgba(21, 61, 111, 0.44)'],
      ['--cwb-connect-button-border-radius', '12px'],
      ['--cwb-connect-button-font-size', '16px'],
      ['--cwb-connect-button-box-shadow--active', 'rgba(55, 107, 173, 0.44) 0px 0px 0px 1pt'],
      ['--cwb-connect-button-background-color--active', 'rgba(55, 107, 173, 0.44)'],
      ['--cwb-connect-button-color--hover', 'rgb(83, 153, 255)'],
      ['--cwb-connect-button-background-color--hover', 'rgba(55, 107, 173, 0.44)'],
      ['--cwb-connect-button-border--hover', 'solid 1px rgba(49, 95, 154, 0.44)'],
      ['--cwb-connect-button-color--focus', 'rgb(83, 153, 255)'],
      ['--cwb-connect-button-background-color--focus', 'rgba(55, 107, 173, 0.44)'],
      ['--cwb-connect-button-border--focus', 'solid 1px rgba(49, 95, 154, 0.44)'],
      ['--cwb-connect-button-box-shadow--focus', 'rgba(55, 107, 173, 0.44) 0px 0px 0px 1pt'],
      ['--cwb-wallet-info-wrapper-background-color', 'rgb(64, 68, 79)'],
      ['--cwb-wallet-info-wrapper-border-radius', '12px'],
      ['--cwb-wallet-info-balance-color', '#ffffff'],
      ['--cwb-wallet-info-balance-font-size', '16px'],
      ['--cwb-wallet-info-button-color', '#ffffff'],
      ['--cwb-wallet-info-button-background-color', 'rgb(44, 47, 54)'],
      ['--cwb-wallet-info-button-border', 'solid 1px rgb(64, 68, 79)'],
      ['--cwb-wallet-info-button-border-radius', '12px'],
      ['--cwb-wallet-info-button-font-size', '16px'],
    ],
  }),
  mounted() {
    setCssVariable(this.rootVariables);
  },
});
